import { ActivityType, CardioOrResistance } from '../../entities';
import { AreaCategory } from '../zone-mappings';
import { CardioOrResistanceActivityTypeMapping } from './cardio-or-resistance-activity-mapping';
import { MarchineZoneActivityTypeMapping } from './marchine-zone-activity-mapping';
import { ActivityTypeMapping } from './workout-activity-mappings';

export function getActivityTypeForAreaCategory(
  cardioOrResistance: CardioOrResistance,
  areaCategory: AreaCategory,
): ActivityType {
  const machineActivityType = ActivityTypeMapping.getActivityTypeFor(
    areaCategory,
    MarchineZoneActivityTypeMapping.buildActivityTypeMap(),
  );
  if (machineActivityType) {
    return machineActivityType;
  }

  if (areaCategory === 'boxing') {
    // boxing is a special kind of Cardio, so handle it first
    return ActivityType.BoxingFitillion;
  }

  const workoutTypeBasedActivityType = ActivityTypeMapping.getActivityTypeFor(
    cardioOrResistance,
    CardioOrResistanceActivityTypeMapping.buildActivityTypeMap(),
  );
  if (workoutTypeBasedActivityType) {
    return workoutTypeBasedActivityType;
  }

  // this should not happen, since everything should at least have CardioOrResistance and be handled above
  return ActivityType.OtherCardio;
}
